import { render, staticRenderFns } from "./SummaryText.vue?vue&type=template&id=ea0a253a&scoped=true&"
import script from "./SummaryText.vue?vue&type=script&lang=js&"
export * from "./SummaryText.vue?vue&type=script&lang=js&"
import style0 from "./SummaryText.vue?vue&type=style&index=0&id=ea0a253a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0a253a",
  null
  
)

export default component.exports